var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"msg-text-inner"},[_vm._l((_vm.splitByStockWords(_vm.msg)),function(word,index){return [(_vm.stockWords.includes(word))?_c('chat-stock-word',{key:index,attrs:{"word":word,"currentStock":_vm.currentStock}}):(word.length > 0)?_c('span',{key:index},[_vm._v(_vm._s(word))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }